// CatalogueUpdateLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';

const CatalogueUpdateLayout = () => {
    return (
        <div>
            <Outlet />
        </div>
    );
};

export default CatalogueUpdateLayout;